import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Fyld vand på fadølsanlæg
          </Heading1>
          <Paragraph>
            Det er meget vigtigt at der er nok vand på anlægget.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="j4dT1uaeDvo" thumbnail="fyld-vand-paa-fadoelsanlaeg" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Det er meget vigtigt, at der nok vand på anlægget. Dette kan tjekkes ved at veje anlægget, som skal veje mere end 44 kg.
          </Paragraph>
          <Paragraph>
            Her mangler der ca. en halv liter. Hvis det er meget varmt i vejret, så er selv
            en smule vand vigtigt for at køle øllet, så det ikke skummer.
          </Paragraph>
          <Paragraph>
            De 4 skruer, som holder låget, skrues af og låget trækkes af mod én selv.
          </Paragraph>
          <Paragraph>
            Tanken med vand er her i venstre side. Til højre sidder kompressoren.
            Dette er motoren. Der findes forskellige versioner.
          </Paragraph>
          <Paragraph>
            Denne type rører rundt i blandingen af is og vand. Den er ikke skruet fast, men skal blot vrikkes op.
          </Paragraph>
          <Paragraph>
            Det er vigtigt at vandet dækker helt op til det øverste rør. Øllet løber inde i denne spiral af stålrør.
          </Paragraph>
          <Paragraph>
            Hvis vandet ikke dækker helt op til, så vil der ikke foregå køling i den øverste del af ølspiralen, hvilket vil forårsage at øllet skummer.
            Da vandet bliver kølet til is og udvider sig, er det vigtigt at man kun fylder op til øverste del af rørene.
          </Paragraph>
          <Paragraph>
            Hvis man fylder for meget vand på kan det ske at isen bliver trykket ud.
            Så fyld kun op til lige midt på øverste rør.
          </Paragraph>
          <Paragraph>
            Så sætter vi motoren på plads igen. Bemærk at på denne ombyggede model, sidder akslen ikke midten.
            Så det er vigtigt at man drejer den så akslen er lige i midten af rørene. Husk at tryk den godt ned så det svubber.
          </Paragraph>
          <Paragraph>
            Prøv gerne at sætte strøm på for at se om motoren drejer frit rundt uden at støde på noget.
            Skru herefter låget på igen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
